import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import { GoldenNotification } from "./";
import { filterWithRelationsAndJson, type RelationalOrJsonEntityFilter } from "@shared/helpers/sql-relations";

const createCustomFilter = createCustomFilterForEntity<GoldenNotification>();

export class GoldenNotificationFilters {
  /**
   * # 🌟✨ HyperFilter – The Ultimate Filtering Powerhouse!
   * ### 🤝 Filter through complex relations effortlessly
   * ### 📦 Directly filter JSON fields (no backend work required!)
   * ### 🚀 Transforms your filter into a single, optimized DB query
   * ### 🔒 Engineered for maximum SQL injection protection
   *
   * ---
   * ### Example:
   * ```ts
   * myEntityRepo.find({
   *  where: MyEntity.hyperFilter({ ... })
   * })
   * ```
   *
   * ---
   * Built by Natan Salmon
   */
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<GoldenNotification>
  >((filters) => {
    return filterWithRelationsAndJson(GoldenNotification)(filters);
  });
}
